//引入api接口
import { fun_PostAction } from "@/api/index";
// 导出
export default {
  // 存储数据
  data: () => {
    // 返回
    return {
      // 数据
      form:{
        title:null, // 项目主题
        content:null, // 内容
        fbksjs:null,// 发布时间
        txtCnt:null // 阅读次数
      },
      // 加载
      loading:false,
      // 一览主键
      guid:null,
    };
  },
   // 模板编译完成
   mounted() {
    // 获取主键
    this.guid = this.$route.query.guid;
    // 执行获取详情方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情数据
     * @author 滕威
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 执行获取列表接口
        fun_PostAction("/hiProperty/propertyAnnouncementBiddingAuctionDetail", {
          guid: this.guid,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 项目主题
            this.form.title = data.title;
            // 内容
            this.form.content=data.content
            // 发布时间
            this.form.fbksjs=data.fbksjs
            // 阅读次数
            this.form.txtCnt=data.txtCnt
          } else {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
  }
};
